module.exports = __webpack_public_path__ + "img/image_8.bf5721e2.png";